import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import fr from 'facet-rest';
import Form from './FormPicker';

const styles = () => ({
  root: {},
});

const WhatIfFacetPlanUpdateTemplate = ({
  className,
  classes,
  resource,
}) => {
  return (
    <WizardStepWrapperTemplate
      className={classNames(className, classes.root)}
      resource={resource}
      LayoutProps={{
        resource,
        collection: resource?.attr('accountsToImport'),
      }}
      layout={Form}
    />
  );
};

WhatIfFacetPlanUpdateTemplate.defaultProps = {
  className: '',
};

WhatIfFacetPlanUpdateTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default withStyles(styles)(WhatIfFacetPlanUpdateTemplate);
